import api from './api';
import { ApiResponse, PageResponse } from '../types';

export interface ExportLog {
  id: number;
  userName: string | null;
  questionnaireId: number | null;
  questionnaireTitle: string | null;
  schoolNames: string | null;
  mode: string | null;
  academicYear: string | null;
  status: 'SUCCESS' | 'FAILED' | null;
  rowCount: number | null;
  fileSizeBytes: number | null;
  durationMs: number | null;
  errorMessage: string | null;
  createdAt: string;
}

export const exportLogService = {
  list: async (page = 0, size = 50): Promise<PageResponse<ExportLog>> => {
    const resp = await api.get<ApiResponse<PageResponse<ExportLog>>>(
      '/admin/export-logs',
      { params: { page, size } }
    );
    return resp.data.data;
  },
};
